import React from 'react'
import R from 'ramda'
import {FormattedMessage} from 'react-intl'
import {connect} from 'react-redux'

import PositioningFields from './PositioningFields'
import NearTo from './NearTo';
import Suggestions from './Suggestions'

import searchPOIByAddress from '../actions/searchPOIByAddress'
import addPoiFromSearch from '../actions/addPoiFromSearch'
import searchFormChange from '../actions/searchFormChange'
import toggleSuggestions from '../actions/toggleSuggestions'

import getCurrentQuery from '../utils/getCurrentQuery'

const PreSearchForm = (props) => {
  const positioningProps = R.pick([
    'options',
    'onChange',
    'query',
  ], props)

  const nearToProps = R.pick([
    'address',
    'options',
    'onAdd',
    'onChange',
    'onDelete',
    'onToggle',
    'onSearch',
    'onChange',
    'onToggleEditFrequency',
    'onSelect',
    'query',
    'searchingPoi',
    'poiOptions',
    'zoom',
    'viewPort',
    'map'    
  ], props)

  const suggestionsProps = R.pick([
    'suggestions',
    'forceSuggestions',
    'onSelectSuggestion',
    'onToggleSuggestions',
    'show',
  ], props)
 
  return <div style={{display: 'flex', flexDirection: 'column'}}>
    <label className="title-category first">
        <FormattedMessage id="Positionning" defaultMessage="Positionning"/>
    </label>

		<PositioningFields {...positioningProps}/>
		
    <label className="title-category">
      <FormattedMessage id="Near to" defaultMessage="Near to"/>
    </label>

    <NearTo {...nearToProps}/>

    <Suggestions {...suggestionsProps}/>

  </div>
}

PreSearchForm.propTypes = {
  onChange: React.PropTypes.func.isRequired,
  onAdd: React.PropTypes.func.isRequired,
  onDelete: React.PropTypes.func.isRequired,
  onToggle: React.PropTypes.func.isRequired,
  onToggleSuggestions: React.PropTypes.func.isRequired,
  onSearch: React.PropTypes.func.isRequired,
  onToggleEditFrequency: React.PropTypes.func.isRequired,
  forceSuggestions: React.PropTypes.bool,
  show: React.PropTypes.object.isRequired,
  onSelectSuggestion: React.PropTypes.func.isRequired,
  searchingPoi: React.PropTypes.bool.isRequired,
  poiOptions: React.PropTypes.array.isRequired,
}

export const StatelessPreSearchForm = PreSearchForm

const mapStateToProps = (state, ownProps) => {
  
  const childMatchingParent = (options, parentList) => {
    const parentIsInList = parentList => option => R.contains(R.prop('parent', option), parentList)
    return R.filter(parentIsInList(parentList), options)
  }
  const filterRegionAndTowns = {
    regions: childMatchingParent(state.options.regions, ownProps.query.provinces),
    towns:   childMatchingParent(state.options.towns,  ownProps.query.regions),
  }
  
  const props = R.pick([
    'viewPort',
    'zoom',
    'map',
    'address',
    'pois',
    'suggestions',
    'show',
    'searchingPoi',
    'poiOptions',
  ], state)
  const options = R.merge(state.options, filterRegionAndTowns)
  return R.assoc("options", options, props)
}

const removePoiFromList = (index, pois) =>
 {
     //must renumber the markerCount when removing an item from the list
     var array = R.remove(index, 1, pois);
     for(var i=0; i<array.length;i++)
     {            
         var poi = array[i];
         if(!!poi.type)
            break;
            
         poi.markerCount = i + 1;
     }
     return array;
 }
 
const mapDispatchToProps = (dispatch) => {
  const onChange = R.curry((fieldName, value) => {
    dispatch(searchFormChange(fieldName, value))
  })
    
  const onAdd = poi => {
    dispatch(addPoiFromSearch(poi.fullAddressSuggestion, {lat: poi.lat, lng: poi.lng}))
  }
  const onToggle = (index) => {
    const query = getCurrentQuery()
    onChange(['pois'], R.adjust(R.evolve({isOpen: R.not()}), index, query.pois))
  }
  const onDelete = (index) => {
    const query = getCurrentQuery()
    onChange(['pois'], removePoiFromList(index, query.pois))
  }
  const onToggleEditFrequency = (index) => {
    const query = getCurrentQuery()
    onChange(['pois'], R.adjust(R.evolve({isEditingFrequency: R.not()}), index, query.pois))
  }
  
  const onSelectSuggestion = (suggestion) => {
    const query = getCurrentQuery()
    onChange(['pois'], R.append(suggestion, query.pois))
  }
  
  const onSelect = (poi, zoom, viewPort, map) => {
    if(zoom<14)
    {
      map.setZoomAround(poi.coordinates,14);
    }
    else if(poi.coordinates.lat>viewPort.topLeft.lat ||
            poi.coordinates.lat<viewPort.bottomRight.lat ||
            poi.coordinates.lng<viewPort.topLeft.lng ||
            poi.coordinates.lng>viewPort.bottomRight.lng)
    {
      map.panTo(poi.coordinates);
    }
  } 
  
  return {
    onAdd,
    onToggle,
    onDelete,
    onChange,
    onToggleEditFrequency,
    onSelectSuggestion,
    onSelect,
    onToggleSuggestions: _ => dispatch(toggleSuggestions()),  
    onSearch: (address) => dispatch(searchPOIByAddress(address)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreSearchForm)


/** WEBPACK FOOTER **
 ** ./app/components/PreSearchForm.jsx
 **/